import {
  React,
  Component,
  PropTypes
} from 'imports/CommonImports';

import {FlatButton} from 'material-ui';

const styles = {
  button: {
    width: '15em',
  },
  label: {
    color: '#FFFFFF',
  },
}

class PrimaryButton extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  render() {
    return(
      <FlatButton
        disabled={this.props.disabled}
        labelStyle={styles.label}
        backgroundColor='#11AB99'
        label={this.props.label}
        onClick={this.props.onClick}
        style={this.props.style || styles.button}
        href={this.props.href}
        />
    );
  }
}

PrimaryButton.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  href: PropTypes.string
}

export default PrimaryButton;



// WEBPACK FOOTER //
// ./src/components/design/PrimaryButtonFlat.js